import { render, staticRenderFns } from "./SlideBeiJingVerify.vue?vue&type=template&id=a1522e84&scoped=true&"
import script from "./SlideBeiJingVerify.vue?vue&type=script&lang=js&"
export * from "./SlideBeiJingVerify.vue?vue&type=script&lang=js&"
import style0 from "./SlideBeiJingVerify.vue?vue&type=style&index=0&id=a1522e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1522e84",
  null
  
)

component.options.__file = "SlideBeiJingVerify.vue"
export default component.exports